import React, { useState, useEffect } from 'react';
import axios from 'axios';
import SearchableSelect from './SearchableSelect';

function ExternalEmployeeSelect({ value, onChange, placeholder = "Select External Employee" }) {
  const [externalEmployees, setExternalEmployees] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchExternalEmployees();
  }, []);

  const fetchExternalEmployees = async () => {
    setLoading(true);
    try {
      const response = await axios.get('/api/externalemployees');
      setExternalEmployees(response.data);
    } catch (error) {
      console.error('Error fetching external employees:', error);
    } finally {
      setLoading(false);
    }
  };

  const options = externalEmployees.map(emp => ({
    value: emp.id,
    label: `${emp.name} - ${emp.mobile} (${emp.department})`
  }));

  return (
    <div>
      <SearchableSelect
        options={options}
        value={value}
        onChange={onChange}
        placeholder={loading ? "Loading employees..." : placeholder}
        disabled={loading}
      />
      {loading && (
        <small className="text-muted">
          <i className="fas fa-spinner fa-spin me-1"></i>
          Fetching employees from external system...
        </small>
      )}
    </div>
  );
}

export default ExternalEmployeeSelect;